import { get, post } from "./base";

const InvoiceServ = {
    index: (params) => get("/invoices", { params }),
    generate: (payload) => post("/invoices/generate", payload),
    download: (orderId) => get(`/invoices/${orderId}`, { responseType: 'blob' }),
};

export default InvoiceServ;
